/**
 * Name: Login Reducer
 * Author: @Gaurav
 * Date: 19-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: {},
  },
  action
) {
  switch (action.type) {
    case 'LOGIN_USER_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'LOGIN_USER_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'LOGIN_USER_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
